export default __webpack_public_path__ + "daabb6e01a815df41adfe7c254a1529d.png";